import { useState, useEffect } from 'react';
import API from '../api/phx';
import * as utils from '../utils/OrderUtils';

const useContactOptionsOrderDetails = (orderId) => {
  const [orderData, setOrderData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const orderUrl = utils.appendGeoParam(`/orders/${orderId}`);
        const response = await API.get(orderUrl);
        const order = response.data;
        setOrderData(order);
        setError(null);
      } catch (err) {
        console.error('Error fetching order details:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [orderId]);

  return { orderData, loading, error };
};

export default useContactOptionsOrderDetails;
